/**
 * Content Management Page for v0.7.0
 * Admin page to manage all ads and wishes
 */

import { useState } from 'react';
import DesktopLayout from '../../../components/layout/DesktopLayout';
import ContentTable from '../../../components/admin/ContentTable';
import './index.css';

const ContentManagementPage = () => {
  const [activeTab, setActiveTab] = useState<'ads' | 'wishes'>('ads');
  const [statusFilter, setStatusFilter] = useState<string>('');

  return (
    <div className="content-management-page">
      <DesktopLayout>
      <main className="content-management-page__main">
        <div className="content-management-page__container">
          <header className="content-management-page__header">
            <h1 className="content-management-page__title">內容管理</h1>
          </header>

          <div className="content-management-page__tabs">
            <button
              className={`content-management-tab ${activeTab === 'ads' ? 'content-management-tab--active' : ''}`}
              onClick={() => setActiveTab('ads')}
            >
              廣告管理
            </button>
            <button
              className={`content-management-tab ${activeTab === 'wishes' ? 'content-management-tab--active' : ''}`}
              onClick={() => setActiveTab('wishes')}
            >
              許願管理
            </button>
          </div>

          <div className="content-management-page__filters">
            <label className="content-management__filter-label">
              狀態篩選：
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="content-management__filter-select"
              >
                <option value="">全部</option>
                {activeTab === 'ads' ? (
                  <>
                    <option value="active">上架中</option>
                    <option value="inactive">已下架</option>
                    <option value="pending">待審核</option>
                  </>
                ) : (
                  <>
                    <option value="open">進行中</option>
                    <option value="matched">已配對</option>
                    <option value="closed">已關閉</option>
                  </>
                )}
              </select>
            </label>
          </div>

          <ContentTable
            type={activeTab}
            status={statusFilter || undefined}
          />
        </div>
      </main>
      </DesktopLayout>
    </div>
  );
};

export default ContentManagementPage;
